import React, { useCallback } from 'react'
import { connect } from 'react-redux'
import { withRouter, Redirect, Link } from 'react-router-dom'
import { Modal, Button, Alert } from 'react-bootstrap';
import * as moment from 'moment';
import * as settings from '../globals/settings'
import * as digitalIdApi from '../api/digitalIdApi'
import Footer from '../components/footer'
import { doRequestUsernameThunk } from '../actions/auth'
import { validateEmail } from '../util/validation'
import NavBar from '../components/navbar'
import '../css/styles.css';
import HelpInfo from '../components/helpInfo'
import Loading from '../components/loading'

class UsernameRequestScreen extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            btnDisabled: true,
            email: null,
            secondEmail: null,
            isChangedError: false,
            usernameErrorMessage: null,
            showModal: false,
            errCode: null,
            errors: {
                email: null,
                secondEmail: null,
            },
        }
    }

    componentDidUpdate(prevProps, prevState){
        if(this.props.strings !== prevProps.strings && prevState.errCode === this.state.errCode && prevState.errCode !== null){
            if(this.state.errCode === 'IIE'){
                this.setState({isChangedError: true, usernameErrorMessage: this.props.strings.REG_ERROR_INVALID_ITEM});
            } else if(this.state.errCode === 'UNF'){
                this.setState({isChangedError: true, usernameErrorMessage: this.props.strings.USER_NOT_FOUND_MESSAGE});
            } else if(this.state.errCode === 'ALO'){
                this.setState({isChangedError: true, usernameErrorMessage: this.props.strings.ALO_PASS_RESET_MESSAGE_1+this.props.strings.FORGOT_UN_LINK+this.props.strings.ALO_PASS_RESET_MESSAGE_2+this.props.strings.FORGOT_PASS_LINK});
            } else if(this.state.errCode === 'UE') {
                this.setState({isChangedError: true, usernameErrorMessage: this.props.strings.UNKNOWN_ERROR_MESSAGE});
            }
        }
        if(this.state.email!==null && this.state.secondEmail!== null && (this.state.email !== prevState.email)){
            if(this.state.secondEmail.trim() !== this.state.email.trim()){
                let err = this.state.errors;
                err.secondEmail = this.props.strings.MISMATCH_EMAILS;
                this.setState({errors:err});
            }
        }
        if((this.state.email !== prevState.email) || (this.state.secondEmail!==prevState.secondEmail)){
            if(this.state.errors.email === null && this.state.errors.secondEmail === null && this.state.email !== null && this.state.secondEmail!==null && this.state.secondEmail.trim() === this.state.email.trim()){
                this.setState({btnDisabled: false});
            }
            else{
                this.setState({btnDisabled: true});
            }
        }
    }

    handleEmailChange = (e) => {
        let err = this.state.errors;
        err.email = null;
        let val = e.target.value.trim();
        if (validateEmail(val)) {
            this.setState({email: val, errors: err });
        } else {
            err.email = this.props.strings.REG_ERROR_INVALID_EMAIL;
            this.setState({email: e.target.value, errors: err });
        }
    }

    handleSecondEmailChange = (e) => {
        let err = this.state.errors;
        err.secondEmail = null;
        let val = e.target.value.trim();
        if (this.state.email !== val && validateEmail(val)) {
            err.secondEmail = this.props.strings.MISMATCH_EMAILS;
            this.setState({secondEmail: val, errors: err});
        } else if(!validateEmail(val)){
            err.secondEmail = this.props.strings.REG_ERROR_INVALID_EMAIL;
            this.setState({secondEmail: e.target.value, errors: err });
        } else {
            this.setState({secondEmail: e.target.value, errors: err});
        }
    }

    handleSubmit = (e) => {
        e.preventDefault();
        this.setState({usernameErrorMessage: null});
;        if(this.state.email !== null && this.state.secondEmail !== null){
            this.props.dispatch(doRequestUsernameThunk(this.state.email))
                .then(() => {
                    // setTimeout(() => {
                        this.setState({ showModal: true });
                    // }, 1000);
                })
                .catch(err => {
                    if(err.code === 'IIE'){
                        this.setState({isChangedError: true, usernameErrorMessage: this.props.strings.REG_ERROR_INVALID_ITEM, errCode: err.code});
                    } else if(err.code === 'UNF'){
                        this.setState({isChangedError: true, usernameErrorMessage: this.props.strings.USER_NOT_FOUND_MESSAGE, errCode: err.code});
                    } else if(err.code === 'ALO'){
                        this.setState({isChangedError: true, usernameErrorMessage: this.props.strings.ALO_PASS_RESET_MESSAGE_1+this.props.strings.ALO_PASS_RESET_MESSAGE_2+this.props.strings.ALO_PASS_RESET_MESSAGE_3, errCode: err.code});
                    } else {
                        this.setState({isChangedError: true, usernameErrorMessage: this.props.strings.UNKNOWN_ERROR_MESSAGE, errCode: err.code});
                    }
                });;
        } else {
            let err = this.state.errors;
            err.secondEmail = this.state.secondEmail === null ? this.props.strings.REG_ERROR_INVALID_EMAIL: null;
            err.email = this.state.email === null ? this.props.strings.REG_ERROR_INVALID_EMAIL: null;
            this.setState({errors: err});
        }
    }

    handleCancel = (e) => {
        e.preventDefault();
        this.props.history.push("/");
    }

    renderUsernameRequestError() {
        if (this.state.isChangedError === false || this.state.usernameErrorMessage === null) {
            return null;
        } else {
            return (
                <div>
                    <span style={{color: 'red', fontWeight: 'bold'}}>Error: {this.state.usernameErrorMessage}</span>
                </div>
            );
        }
    }

    // FIXME Not sure what should go here?
    renderError(key) {
        if (this.state.errors[key])  {
            return (
                <div className="invalid-feedback">{this.state.errors[key]}</div>
            );
        } else {
            return null;
        }
    }

    renderErrorClass(key) {
        let c = "form-control";
        if (this.state.errors[key])  {
            c = "form-control is-invalid";
        }
        return c;
    }

    validate(dto) {
        let error = null;
        // Check required fields..
        // All fields are required right now.
        Object.entries(dto).forEach((o) => {
            if (o == null) {
                error = this.props.strings.MISSING_REQUIRED_FIELDS;
            }
        });

        // Check for errors.
        Object.entries(this.state.errors).forEach((e) => {
            if (e[1] !== null) {
                error = e;
            }
        });
        return error;
    }

    renderModal(){
        return (
            <Modal
                className="Modal positionModal"
                show={this.state.showModal}
                centered={true}
                scrollable={true}
                onHide={() => this.setState({ showModal:false })}
            >
                <Modal.Header>
                    <Modal.Title>
                        {this.props.strings.USERNAME_REQUEST_LABEL}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>{this.props.strings.USERNAME_REQUEST_INFO_1}</p>
                    <p>{this.props.strings.USERNAME_REQUEST_INFO_2}</p>
                    <p>{this.props.strings.USERNAME_REQUEST_INFO_4}</p>
                </Modal.Body>
                <Modal.Footer>
                    <div className="d-flex justify-content-end">
                        <Button onClick={ () => this.props.history.push("/") } variant="outline-success">
                            {this.props.strings.RETURN_BUTTON}
                        </Button>
                    </div>
                </Modal.Footer>
            </Modal>
        );
    }

    renderLoadingModal(){
        if (this.props.isLoadingRegister === true) {
            return (
                <Modal
                    size="lg"
                    show={true}
                    centered={true}
                    scrollable={true}
                    onHide={false}
                >
                    <Modal.Body>
                        <Loading />
                    </Modal.Body>
                </Modal>
            );
        } else {
            return null;
        }
    }

    render() {
        if (this.props.isError === true) {
            return <Redirect to="error" />
        }

        return (
            <div className="container-full">
                <NavBar language={this.props.language}/>
                {this.renderModal()}
                <div className="container justify-content-center align-items-center">
                    <div class="alert alert-info" role="alert">
                        <h4>{this.props.strings.USERNAME_REQUEST_LABEL}</h4>
                        <p>{this.props.strings.USERNAME_REQUEST_MESSAGE} <Link to="login">{this.props.strings.RETURN_BUTTON}</Link></p>
                    </div>
                    {/* {this.renderLoadingModal()} */}
                    <form onSubmit={this.handleSubmit} className="formMargin">
                        <div class="form-group">
                            <HelpInfo helpInfoText={this.props.strings.USERNAME_REQUEST_TOOLTIP} labelText={this.props.strings.USERNAME_REQUEST_EMAIL_LABEL} />
                            <input class={this.renderErrorClass('email')} id="username-input" placeholder={this.props.strings.USERNAME_REQUEST_EMAIL_LABEL} onChange={this.handleEmailChange}/>
                            {this.renderError('email')}
                        </div>
                        <div class="form-group">
                            <HelpInfo helpInfoText={this.props.strings.USERNAME_REQUEST_TOOLTIP} labelText={this.props.strings.RETYPE_EMAIL_LABEL}/>
                            <input class={this.renderErrorClass('secondEmail')} id="username-input" placeholder={this.props.strings.RETYPE_EMAIL_LABEL} onChange={this.handleSecondEmailChange}/>
                            {this.renderError('secondEmail')}
                        </div>
                        {this.renderUsernameRequestError()}
                        <div className="row justify-content-center">
                            <button type="submit" class={ this.state.btnDisabled ? "btn btn-secondary custom-button":"btn btn-primary custom-button" } disabled={this.state.btnDisabled} >{this.props.strings.SUBMIT_BUTTON_LABEL}</button>
                        </div>
                        <div className="row justify-content-center">
                            <button type="button" class="btn btn-link" onClick={this.handleCancel} >{this.props.strings.CANCEL_BUTTON_LABEL}</button>
                        </div>
                    </form>
                    <div class="alert alert-info">
                        <p>{this.props.strings.USERNAME_REQUEST_INFO_1}</p>
                        <p>{this.props.strings.USERNAME_REQUEST_INFO_2}</p>
                        <p>{this.props.strings.USERNAME_REQUEST_INFO_3}</p>
                    </div>
                </div>
                <Footer />
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        authorizeUrl: state.auth.authorizeUrl,
        isLoadingLogin: state.auth.isLoadingLogin,
        isLoadingRegister: state.auth.isLoadingRegister,
        isChangedError: state.auth.isChangedError,
        isFakeLoggedIn: state.auth.isFakeLoggedIn,
        strings: state.language.strings,
        language: state.language.language,
        isError: state.api.isError,
    }
}

const ConnectedUsernameRequestScreen = connect(
    mapStateToProps
)(UsernameRequestScreen);

export default withRouter(ConnectedUsernameRequestScreen);